import Users from "./Users.vue";
import Show from "./Show.vue";

import { Router as BcpRouter, Root as BcpRoot } from "./BCP";
import { Router as RulesRouter, Root as RulesRoot } from "./Rules";
import { Router as TrainingRouter, Root as TrainingRoot } from "./Trainings";

export default [
  {
    path: "users",
    name: "UsersSystemAdminUsers",
    component: Users,
    meta: {
      title: "会員管理",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
      ],
    },
  },
  {
    path: "users/show",
    name: "UsersSystemAdminShow",
    component: Show,
    meta: {
      title: "管理者情報",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
      ],
    },
  },
  {
    path: "bcp",
    component: BcpRoot,
    children: BcpRouter,
  },
  {
    path: "rules",
    component: RulesRoot,
    children: RulesRouter,
  },
  {
    path: "training",
    component: TrainingRoot,
    children: TrainingRouter,
  },
];
